<div class="admin-shell">
  <aside class="sidebar">
    <div class="brand">
      <img src="assets/logo.png" alt="Capital Hub">
      <div>
        <div class="brand-title">Capital Hub</div>
        <div class="brand-subtitle">Admin Portal</div>
      </div>
    </div>

    <nav class="nav flex-column gap-1">
      <a routerLink="/dashboard" routerLinkActive="active" class="nav-link">
        <i class="bi bi-speedometer2"></i>
        Dashboard
      </a>
      <a routerLink="/employers" routerLinkActive="active" class="nav-link">
        <i class="bi bi-buildings"></i>
        Employers
      </a>
      <a class="nav-link disabled">
        <i class="bi bi-shield-check"></i>
        Verifications
      </a>
      <a routerLink="/loan-config" routerLinkActive="active" class="nav-link">
        <i class="bi bi-sliders"></i>
        Loan Config
      </a>
      <a routerLink="/fund-pool" routerLinkActive="active" class="nav-link">
        <i class="bi bi-bank"></i>
        Fund Pool
      </a>
      <a routerLink="/admin-users" routerLinkActive="active" class="nav-link">
        <i class="bi bi-people"></i>
        Admin Users
      </a>
    </nav>

    <button class="nav-link logout-link" type="button" (click)="logout()">
      <i class="bi bi-box-arrow-right"></i>
      Log out
    </button>
  </aside>

  <main class="content">
    <header class="topbar">
      <div>
        <div class="eyebrow">Operations</div>
        <h1>Admin Console</h1>
      </div>
    </header>
    <router-outlet />
  </main>
</div>
